import Avatar from "../../../Atoms/Avatar";
import AvatarLetter from "../../../Atoms/AvatarLetter";
import ReviewStars from "./ReviewStars";
import TextCollapse from "../../../Atoms/TextCollapse";
import styles from "./styles.module.scss";

interface Props {
  stars: number;
  text: string;
  date: string;
  userName: string;
  profileImageUrl: string | null;
}

export default function Review({
  text,
  stars,
  date,
  userName,
  profileImageUrl,
}: Props) {
  return (
    <div className={styles["GuideReview"]}>
      <div className={styles["GuideReviewContent"]}>
        <div className={styles["GuideReviewAvatar"]}>
          {profileImageUrl ? (
            <Avatar name={"userName"} size={72} src={profileImageUrl} />
          ) : (
            <AvatarLetter size={72} name={userName} />
          )}

          <div
            style={{
              fontSize: 14,
              textAlign: "center",
              color: "#2E2E2E",
              marginTop: 2,
            }}
          >
            {userName ?? "Anonymous"}
          </div>
        </div>
        <div className={styles["GuideReviewText"]}>
          <ReviewStars rating={stars} />{" "}
          <span style={{ fontSize: 13, display: "none" }}>
            reviewed {date.split(" ")[0]}
          </span>
          <p style={{ color: "#777778", fontSize: 12 }}>
            {text ? <TextCollapse text={text} /> : null}
          </p>
        </div>
      </div>
    </div>
  );
}
